import { motion } from "framer-motion";
import { LIFESTYLE } from "@/data/products";

export default function AboutSection() {
  return (
    <section className="py-24 lg:py-32 bg-background" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <img src={LIFESTYLE.factory} alt="SBC production" className="rounded-2xl aspect-[4/5] object-cover w-full shadow-2xl" />
            <div className="absolute -bottom-6 -right-6 bg-neutral-950 text-white p-6 rounded-2xl max-w-[220px] shadow-2xl">
              <div className="font-display font-black text-3xl gold-gradient-text">2026</div>
              <div className="text-xs text-neutral-400 mt-1 uppercase tracking-widest">Incorporated 6 July 2026 · Manchester, UK</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 space-y-6">
          <div className="eyebrow">About SBC Ltd</div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-display font-bold text-4xl lg:text-5xl tracking-tighter leading-tight"
          >
            A British beverage house with a truly global soul.
          </motion.h2>
          <div className="gold-line max-w-[80px]" />
          <div className="space-y-4 text-base text-muted-foreground leading-relaxed max-w-2xl">
            <p>
              Scitygate Brewing Company Ltd (SBC Ltd) is a UK-registered beverage company incorporated in July 2026. Based in Manchester, United Kingdom, the company is developing a portfolio of beverage brands, including Maltora, OneCola, VoltX, OneFresh and OneSpring.
            </p>
            <p>
              SBC Ltd is focused on product development, brand innovation, manufacturing partnerships and building distribution opportunities across the United Kingdom and international markets.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 pt-6">
            {[
              { n: "5", l: "Brand Families" },
              { n: "2026", l: "Incorporated" },
              { n: "UK", l: "Manchester HQ" },
              { n: "17323558", l: "Company No." },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-display font-bold text-3xl gold-gradient-text">{s.n}</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
